<div class="filter-list-container">
    <h3> {{filterName}} </h3>
    <div class="mat-elevation-z2" style="margin: 5px; width: 100%">
        <mat-form-field class="search-field">
            <mat-label>Search</mat-label>
            <input matInput (keyup)="applySearchFilter($event)" placeholder="Ex. Lidar, RGo, Camera..." #input>
        </mat-form-field>

        <div class="table-container">
            <table mat-table [dataSource]="dataSource">
                <!-- Checkbox Column -->
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (click)="toggleAllRows()"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="onCheckboxChange(row)" [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                        </mat-checkbox>
                    </td>
                </ng-container>

                @for (column of columnsToDisplay; track column) {
                @if (column != "select"){
                <ng-container matColumnDef="{{column}}">
                    <th mat-header-cell *matHeaderCellDef> {{column}} </th>
                    <td mat-cell *matCellDef="let element"> {{element}} </td>
                </ng-container>
                }
                }

                <tr mat-header-row *matHeaderRowDef="columsWithSelect"></tr>
                <tr mat-row *matRowDef="let row; columns: columsWithSelect;">
                </tr>
            </table>
        </div>
    </div>
</div>
